import {Accordion, Card, Col, Row, Table} from "react-bootstrap";
import React from "react";
import moment from "moment-timezone";

export default class GroupLiensMonthSummary extends React.Component {

    goToLien = (patientId, lienId) => {
        console.log(`patient ${patientId} lien ${lienId}`)
        window.location.href = `/liens/patients/${patientId}?lienId=${lienId}`;
    }

    render() {
        let m = this.props.month;
        let liens = m.liens || [];

        return <Accordion>
            <Card>
                <Accordion.Toggle as={Card.Header} eventKey={m.displayName} onClick={() => this.setState({clicked: true})} className={"clickable p-2"}>
                    <Row>
                        <Col xs={6}>{m.displayName}</Col>
                        <Col xs={6} className={"text-right"}>{liens.length} Liens</Col>
                    </Row>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={m.displayName}>
                    <Card.Body>
                            <Table striped size={"sm"} hover>
                                <thead>
                                <tr>
                                    <th>Rec'd</th>
                                    <th>DOI</th>
                                    <th>Patient</th>
                                    <th>Bill Type</th>
                                    <th>Status</th>
                                </tr>
                                </thead>
                                <tbody>
                                {liens.map((l, index) => <tr className={"clickable"} key={l.id} onClick={() => this.goToLien(l.patientId, l.id)}>
                                    <td>{moment(l.initialDate).format("M/D/YYYY")}</td>
                                    <td>{l.dateOfInjury ? moment(l.dateOfInjury).format("M/D/YYYY") : ""}</td>
                                    <td>{l.patientLast}, {l.patientFirst} ({l.accountNumber})</td>
                                    <td>{l.billType}</td>
                                    <td>{l.status}</td>
                                </tr>)}
                                </tbody>
                            </Table>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    }
}